<script setup lang="ts">
import { faClose, faPlus } from '@fortawesome/pro-regular-svg-icons';
import ImagePreview from './ImagePreview.vue';

const images = defineModel<File[]>({ default: () => [] });

const { openFileSelect, removeFile, files } = useDropzone({
    dataTypes: ['image/*'],
    onChange: files => {
        images.value = files.map(({ file }) => file);
    },
    webAppFileType: 'image',
});

const { open } = useModal({ component: ImagePreview });

const urls = computed(() =>
    files.value.map(({ file }) => URL.createObjectURL(file))
);
</script>
<template>
    <div class="images-row">
        <div class="add-button" @click="openFileSelect()">
            <mr-icon :icon="faPlus" color="var(--blue-400)" />
            <mr-typography color="var(--blue-400)"> افزودن عکس </mr-typography>
        </div>
        <div
            v-for="(src, index) in urls"
            :key="index"
            class="preview"
            @click="open({ src })"
        >
            <img :src alt="uploaded" />
            <mr-button
                size="small"
                class="remove-image"
                :icon-button="faClose"
                @click.stop="removeFile(files[index].id)"
            />
        </div>
    </div>
</template>
<style scoped lang="scss">
.images-row {
    display: flex;
    gap: 12px;
    @include no-scrollbar;
    overflow-x: auto;
    .hidden {
        display: none;
    }
    .add-button {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        width: 100px;
        height: 100px;
        flex-shrink: 0;
        border: 1px solid usePalette();
        @include shadow();
        &:hover {
            @include shadow(3);
        }
    }
    .preview {
        position: relative;
        width: 100px;
        height: 100px;
        border-radius: 8px;
        overflow: hidden;
        flex-shrink: 0;
        cursor: pointer;
        &:hover {
            .remove-image {
                opacity: 1;
            }
        }
        img {
            width: 100%;
            height: 100%;
            object-fit: fill;
        }
        .remove-image {
            position: absolute;
            top: 5px;
            left: 5px;
            opacity: 0;
            transition: opacity 0.3s;
        }
    }
}
</style>
